module.exports = __webpack_public_path__ + "static/media/Workl_Brand_Colours.45567f94.png";